<template>
    <div class="searchBar">
        <div class="searchBCen">
          <div class="searchBCenGy">
            <p class="searchBCenGM">关于我们</p>
            <p class="searchBCenGBottom" @click="goAboutUs">企业文化</p>
            <p class="searchBCenGBottom" @click="goAboutUs">发展历程</p>
            <p class="searchBCenGBottom" @click="goAboutUs">联系我们</p>
            <p class="searchBCenGBottom" @click="goAboutUs">加入我们</p>
          </div>
          <div class="searchBCenGy">
            <p class="searchBCenGM">解决方案</p>
            <p class="searchBCenGBottom" @click="goSolve">企业管理系统</p>
            <p class="searchBCenGBottom" @click="goSolve">仓储集成项目</p>
            <p class="searchBCenGBottom" @click="goSolve">工业智能化</p>
          </div>
          <div class="searchBCenGy">
            <p class="searchBCenGM">热门产品</p>
            <p class="searchBCenGBottom" @click="goProduct('/wmsView')">仓储WMS系统</p>
            <p class="searchBCenGBottom" @click="goProduct('/commerce')">电子商务平台</p>
            <p class="searchBCenGBottom" @click="goProduct('/repView')" >时空资源计划管理系统</p>
            <!-- <p class="searchBCenGBottom" @click="goProduct('/repView')">ERP管理系统</p> -->
            <p class="searchBCenGBottom" @click="goProduct('/omsView')">OMS管理系统</p>
          </div>
          <div class="searchBCenGy">
            <p class="searchBCenGM">服务</p>
            <p class="searchBCenGBottom" @click="goContactUs" >咨询服务</p>
            <p class="searchBCenGBottom" @click="goContactUs" >软件开发服务</p>
            <p class="searchBCenGBottom" @click="goContactUs" >培训实施服务</p>
            <p class="searchBCenGBottom"><a href="http://gd.zzskzy.com/#/login">客服工单服务</a></p>
          </div>
          <div class="searchBCenimage">
            <p>扫一扫，关注我们</p>
            <img src="./img/weixingongzhonghao.png" alt="" />
            <p>郑州时空微信公众号</p>
          </div>
        </div>
        <div class="searchBGfRX">
            <p><span class="el-icon-mobile-phone"> </span>官方服务热线：400-991-9533</p>
            <p><span class="el-icon-message"></span>公司邮箱：zzskrj@126.com</p>
            <p><span class="el-icon-location"></span>地址：郑州市经济开发区航海东路与二十三大街中科智谷创新园12号楼7层</p>
        </div>
        <div class="sehBottom">
          <span>©2023郑州时空智友信息技术有限公司 豫ICP备08271723号 粤公网安备 78885959655645号</span>
          <span>法律声明及隐私政策</span>
        </div>
    </div>
</template>

<script>
export default {
  name: 'searchBar',
  data () {
    return {

    }
  },
  methods: {
    goAboutUs () {
      this.$router.push('/aboutUs')
      this.$store.commit('getActiveIndex', '/aboutUs')
      localStorage.setItem('index', '/aboutUs')
    },
    goSolve () {
      this.$router.push('/solve')
      this.$store.commit('getActiveIndex', '/solve')
      localStorage.setItem('index', '/solve')
    },
    // 跳转练习我们
    goContactUs () {
      this.$router.push('/contactUs')
      this.$store.commit('getActiveIndex', '/contactUs')
      localStorage.setItem('index', '/contactUs')
    },
    goProduct (product) {
      this.$router.push(product)
      this.$store.commit('getActiveIndex', product)
      localStorage.setItem('index', product)
    }
  },
  components: {

  }
}
</script>

<style lang="scss" scoped>
// pc高度比
// $sun:75/192;
$sun:100/192;
// 底部
.searchBar {
  display: flex;
  // justify-content: flex-end;
  align-items: center;
  flex-wrap: wrap;
  width: 100%;
  height: 600px*$sun;
  min-height: 40px*$sun;
  // padding: 0px 20px 0px 0;
  box-sizing: border-box;
  background: url('./img/backImg.png') no-repeat;
  background-size:100% 100%;
  border-bottom: 0.5px solid #dcdcdc;
}
.searchBCen {
  width: 1400px*$sun;
  height: 399px*$sun;
  margin: 0 auto;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding:  0 40px*$sun;
  border-bottom: 1px*$sun solid rgba(255, 255, 255, 0.26);
  .searchBCenGy {
    float: left;
    width: 150px*$sun;
    height: 232px*$sun;
    display: flex;
    justify-content: space-between;
    flex-direction: column;
    margin-top: 80px*$sun;
    margin-bottom: 80px*$sun;
    margin-right: 100px*$sun;
    // height: 180px*$sun;
    .searchBCenGBottom {
      display: flex;
      justify-content: flex-start;
      font-size: 14px*$sun;
      color: #8E96A1;
      margin-top: 17px*$sun;
      margin-bottom: 17px*$sun;
      font-weight: 500;
    }
    .searchBCenGBottom:hover{
    color: #FFF;
    cursor:pointer;
  }
    .searchBCenGM {
      font-size: 18px*$sun;
      font-weight: 500;
      // margin-bottom: 10px*$sun;
      color: #fff;
    }
  }
  .searchBCenimage {
    float: left;
    margin-top: 80px*$sun;
    margin-bottom: 80px*$sun;
    padding-top: 17px*$sun;
    width: 230px*$sun;
    height: 232px*$sun;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: space-between;

    img {
      display:block;
      width: 130px*$sun;
      height: 130px*$sun;
      margin:auto;
    }
    p {
      width: 130px*$sun;
      font-size: 14px*$sun;
      color: #fff;
      width: 100%;
      text-align: center;
      font-weight: 500;
    }
  }
}
.searchBGfRX{
  width: 1480px*$sun;
  height:100px*$sun;
  margin: 0 auto;
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 12px*$sun;
  color: #8E96A1;
  border-bottom: 1px*$sun solid rgba(255, 255, 255, 0.26);
  // border-color: rgba(255, 255, 255, 0.26);
  p{
    float: left;
    text-align: center;
    font-weight: 500;
    span{
      display: inline-block;
      width: 20px*$sun;
      height: 20px*$sun;
      border-radius: 50%;
      border: 1px solid#AAAAAA;
      text-align: center;
      line-height: 20px*$sun;
      margin-right: 10px*$sun;
      color: #8E96A1;
      font-size: 12px*$sun;
    }
  }
}
.sehBottom{
  width: 1480px*$sun;
  margin: 0 auto;
  height:100px*$sun;
  font-size: 14px*$sun;
  color: #8E96A1;
  display: flex;
  align-items: center;
  justify-content: space-between;
  span{
    font-weight: 500;
  }
}
</style>
